document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom-rotation-slider__slider').forEach(function(slider) {
      const cards = slider.querySelectorAll('.custom-rotation-slider__card');
      const prevBtn = slider.querySelector('.custom-rotation-slider__arrow--prev');
      const nextBtn = slider.querySelector('.custom-rotation-slider__arrow--next');
      let current = 0;
  
      function updateSlider() {
        cards.forEach((card, idx) => {
          card.classList.remove('is-center', 'is-left', 'is-right');
          card.style.display = 'none';
        });
        if (cards.length === 0) return;
        cards[current].classList.add('is-center');
        cards[current].style.display = 'flex';
        if (current > 0) {
          cards[current - 1].classList.add('is-left');
          cards[current - 1].style.display = 'flex';
        } else if (cards.length > 1) {
          cards[cards.length - 1].classList.add('is-left');
          cards[cards.length - 1].style.display = 'flex';
        }
        if (current < cards.length - 1) {
          cards[current + 1].classList.add('is-right');
          cards[current + 1].style.display = 'flex';
        } else if (cards.length > 1) {
          cards[0].classList.add('is-right');
          cards[0].style.display = 'flex';
        }
      }
  
      if (prevBtn && nextBtn && cards.length > 0) {
        prevBtn.addEventListener('click', function () {
          current = (current - 1 + cards.length) % cards.length;
          updateSlider();
        });
  
        nextBtn.addEventListener('click', function () {
          current = (current + 1) % cards.length;
          updateSlider();
        });
  
        updateSlider();
      }
  
      // Touch/Swipe support
      let touchStartX = null;
      let touchEndX = null;
  
      slider.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) {
          touchStartX = e.touches[0].clientX;
        }
      });
      slider.addEventListener('touchmove', function (e) {
        if (e.touches.length === 1) {
          touchEndX = e.touches[0].clientX;
        }
      });
      slider.addEventListener('touchend', function () {
        if (touchStartX !== null && touchEndX !== null) {
          const diff = touchEndX - touchStartX;
          if (Math.abs(diff) > 40) {
            if (diff < 0) {
              current = (current + 1) % cards.length;
              updateSlider();
            } else {
              current = (current - 1 + cards.length) % cards.length;
              updateSlider();
            }
          }
        }
        touchStartX = null;
        touchEndX = null;
      });
  
      // Mouse drag support for desktop
      let isDragging = false;
      let mouseStartX = null;
      let mouseEndX = null;
  
      slider.addEventListener('mousedown', function (e) {
        isDragging = true;
        mouseStartX = e.clientX;
      });
      slider.addEventListener('mousemove', function (e) {
        if (isDragging) {
          mouseEndX = e.clientX;
        }
      });
      slider.addEventListener('mouseup', function () {
        if (isDragging && mouseStartX !== null && mouseEndX !== null) {
          const diff = mouseEndX - mouseStartX;
          if (Math.abs(diff) > 40) {
            if (diff < 0) {
              current = (current + 1) % cards.length;
              updateSlider();
            } else {
              current = (current - 1 + cards.length) % cards.length;
              updateSlider();
            }
          }
        }
        isDragging = false;
        mouseStartX = null;
        mouseEndX = null;
      });
      slider.addEventListener('mouseleave', function () {
        isDragging = false;
        mouseStartX = null;
        mouseEndX = null;
      });
    });
  });